import { render, staticRenderFns } from "./IdentityConfirmView.vue?vue&type=template&id=a8958d3e&scoped=true&"
import script from "./IdentityConfirmView.vue?vue&type=script&lang=js&"
export * from "./IdentityConfirmView.vue?vue&type=script&lang=js&"
import style0 from "./IdentityConfirmView.vue?vue&type=style&index=0&id=a8958d3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8958d3e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Jenkins_Home\\workspace\\liveinfo3-front-admin-dev\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a8958d3e')) {
      api.createRecord('a8958d3e', component.options)
    } else {
      api.reload('a8958d3e', component.options)
    }
    module.hot.accept("./IdentityConfirmView.vue?vue&type=template&id=a8958d3e&scoped=true&", function () {
      api.rerender('a8958d3e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/statistics/sign-draw/view/IdentityConfirmView.vue"
export default component.exports